import { Component, OnInit, ViewChild, AfterViewInit, HostListener } from '@angular/core';
import { Appointment } from 'src/app/models/appointment.model';
import * as moment from 'moment';

import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import multiMonthPlugin from '@fullcalendar/multimonth'
import interactionPlugin from '@fullcalendar/interaction';
import rrulePlugin from '@fullcalendar/rrule';
import { FullCalendarComponent } from '@fullcalendar/angular';
import { EventInput, Calendar, CalendarOptions, DatesSetArg, EventClickArg, DayCellMountArg } from '@fullcalendar/core';
import { APIServiceService } from 'src/app/api/apiservice.service';
import { Customer } from 'src/app/models/customer.model';
import { APIResponse } from 'src/app/models/api-response.model';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { AppointmentType } from 'src/app/models/appointment-type.model';
import { Location } from '@angular/common';

import { isSameMonth, startOfMonth, addMonths, getDate, add, format } from 'date-fns';
import { AppointmentEditSlideoverComponent } from '../appointment-edit-slideover/appointment-edit-slideover.component';
import { AppointmentEditorService } from 'src/app/services/appointment-editor.service';
import { Subscription } from 'rxjs';
import { ModalService } from 'src/app/services/modal.service';

interface RRuleObject {
  freq?: string;
  dtstart?: string;
  until?: string;
  exdate?: string[];
}


@Component({
  selector: 'ubc-calendar-page',
  templateUrl: './calendar-page.component.html',
  styleUrls: ['./calendar-page.component.scss']
})
export class CalendarPageComponent implements OnInit, AfterViewInit {
  startTime = '2020-03-07 13:00:00';
  endTime = '2020-03-07 15:00:00';

  gettingGoogleEvents = false

  eventSubscription: Subscription

  constructor(
    private apiService: APIServiceService, 
    private router: Router,
    private location: Location,
    private activatedRoute: ActivatedRoute,
    private appointmentEditorService: AppointmentEditorService,
    private modalService: ModalService
  ) { }
  appointment: Appointment = null;
  @ViewChild('calendar', {}) private calendarComponent: FullCalendarComponent; // the #calendar in the template

  calenderPlugins = [dayGridPlugin, timeGridPlugin, interactionPlugin, multiMonthPlugin, rrulePlugin];
  
  private calendarApi: Calendar;
  calendarEvents: EventInput[] = [];
  additionalCalendarId: string; // if set this will be the ID of the additional google calendar events to show
  calendarRatio = 1.3;

  businessHours = {
    // days of week. an array of zero-based day of week integers (0=Sunday)
    daysOfWeek: [ 1, 2, 3, 4, 5, 6 ], // Monday - Thursday
    startTime: '08:00', // a start time (10am in this example)
    endTime: '18:00', // an end time (6pm in this example)
  }

  readyForCalendar = false
  calendarViewUpdatedByUser: boolean = false

  calendarOptions: CalendarOptions = {
    
  }

  private onDayCellMount(arg: DayCellMountArg) {
    console.log("onDayCellMount")
    // arg.date is a native Date
    // arg.el   is the <td> element that FullCalendar rendered
    const badge = document.createElement('span');
    badge.classList.add('my-badge');
    badge.textContent = '📌';
    // for example only on weekends:
    if (arg.date.getDay() === 0 || arg.date.getDay() === 6) {
      // find the container for the day number (depending on version):
      const topEl = arg.el.querySelector('.fc-daygrid-day-top') || arg.el;
      topEl.appendChild(badge);
    }
  }

  ngAfterViewInit(){
    console.log("ngAfterViewInit")
    if(!this.calendarComponent){
      return;
    }
    this.calendarApi = this.calendarComponent.getApi();

    this.calendarRatio = window.screen.availWidth / window.screen.availHeight;
    console.log("ngAfterViewInit", this.calendarRatio)

    this.apiService.user.getMeta('gcal_id')
    .then((response) => {
      if(response.success && response.data.meta_key === 'gcal_id') {
        this.additionalCalendarId = response.data.meta_value;
      }
       this.viewWasRendered();
    })
    .catch((err) => {
      this.viewWasRendered();
      console.log(err)
    });



  }

  ngOnInit() {
    console.log("ngOnInit")
    this.calendarRatio = window.screen.availWidth / window.screen.availHeight;
    console.log("ngOnInit", this.calendarRatio)
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      const viewType = params['view']
      const startDateStr = params['start']
      const appointmentIdString = params['appt']

      let startDate = (startDateStr) ? new Date(decodeURIComponent(startDateStr)) : new Date()

      this.loadCalendar(viewType, startDate)


      if(appointmentIdString){
        if(appointmentIdString === "new"){
          this.removeUrlParam("appt")
        } else {
          setTimeout(() => {
            this.openAppointmentPane(false, new Appointment())
          }, 1000)
          
          
        }
      }



      
    })

    this.eventSubscription = this.modalService.event$.subscribe(event => {
      if (event.type === 'APPOINTMENTS') {
       console.log("Customer event recieved ", event)

       if(event.action === "refresh_required" ){
          this.populateEventsToCalendar()
       }
      }
    });
  }

  loadCalendar(initialView: string, startDate: Date){
    this.calendarOptions = {
      
      initialView: initialView || 'multiMonthYear',
      plugins: this.calenderPlugins,
      multiMonthMaxColumns:1,
      headerToolbar: {
        left: 'prev,next,today',
        center: 'title',
        right: 'timeGridDay,timeGridWeek,dayGridMonth,multiMonthYear'
      },
      nowIndicator: true,
      aspectRatio: this.calendarRatio,
      businessHours: this.businessHours,
      dayMaxEvents: 8,
      dayMaxEventRows: 8,
      
      firstDay: 1,
      slotMinTime: "06:00:00",
      slotMaxTime: "20:00:00",
      dateClick: (arg)=>this.handleDateClick(arg),
      eventClick: (arg) => this.handleEventClick(arg),
      eventDrop: (arg) => this.eventWasDragged(arg),
      eventResize: (arg) => this.eventWasResized(arg),
      datesSet: (arg) => this.handleCalendarDatesSet(arg),
      initialDate: startDate,
      
      // dayCellDidMount: this.onDayCellMount.bind(this),
      
      
    }

    this.readyForCalendar = true
  }

  removeUrlParam(paramToRemove: string) {
    // Get the current URL path
    const currentPath = this.location.path().split('?')[0];
  
    // Get the current query parameters
    const searchParams = new URLSearchParams(this.location.path().split('?')[1]);
  
    // Delete the parameter you want to remove
    searchParams.delete(paramToRemove);
  
    // Construct the new query string
    const queryParams = searchParams.toString();
  
    // Update the URL
    this.location.replaceState(`${currentPath}?${queryParams}`);
  }

  addUrlParam(key: string, value: string ) {
    // Get the current URL path
    const currentPath = this.location.path().split('?')[0];
  
    // Get the current query parameters
    const searchParams = new URLSearchParams(this.location.path().split('?')[1]);
    // Add the parameter you want to add
    if(!searchParams.has(key)){
      searchParams.append(key, value)
    } else {
      searchParams.set(key, value)
    }
  
    // Construct the new query string
    const queryParams = searchParams.toString();
  
    // Update the URL
    this.location.replaceState(`${currentPath}?${queryParams}`);
  }

  updateUrlWithParams(params: { [key: string]: any }) {
    // Get the current URL path
    const currentPath = this.location.path().split('?')[0];

    // Construct the new query string
    // const queryParams = new URLSearchParams(params).toString();

    // Update the URL
    // this.location.replaceState(`${currentPath}?${queryParams}`);

    Object.keys(params).forEach((key) => {
      this.addUrlParam(key, params[key])
    })

  }

  updateURLForView(args: DatesSetArg | EventClickArg, eventClicked?: boolean) {
    
    

    let params: any = {
      view: args.view.type,
      start: (!eventClicked) ? this.toLocalISOString((args as DatesSetArg).view.activeStart) : this.toLocalISOString((args as EventClickArg).view.activeStart)
      
    }

    if(eventClicked){
      params.appt = (args as EventClickArg).event.id
    }

    if(!eventClicked){

     

      if(params.view === "multiMonthYear"){
        params.start = this.toLocalISOString(new Date())
      }


    } 
    
    this.updateUrlWithParams(params);
  }



  

  calendarEventRender($event){
   // $event.timeFormat
  }

 

  handleCalendarDatesSet(args: DatesSetArg) {
    
    if(this.calendarViewUpdatedByUser){
     
      this.updateURLForView(args)
    } else {
      this.calendarViewUpdatedByUser = true
    }
    
    
    this.viewWasRendered()

   


  }

  viewWasRendered() {
    if(!this.calendarApi){
      return;
    }

    

    this.calendarEvents = [];
    this.populateEventsToCalendar();
  }

  async populateEventsToCalendar(){
    const startDate = format(add(this.calendarApi.view.currentStart, { days: -7}), 'yyyy-MM-dd' )
    const endDate = format(add(this.calendarApi.view.currentEnd, { days: 7}), 'yyyy-MM-dd' )

    try {
      
      const apppontmentsResponse = await this.apiService.appointments.getWithinDates(startDate, endDate, false)
      if(!apppontmentsResponse.success){
        return
      }

      this.calendarEvents = []

      // Iterate and populate appointment events
      apppontmentsResponse.data.forEach((eventObject) => {
        const customer = new Customer().deserialize(eventObject.customer);
        var classString = 'fitter-' + eventObject.fitter.id;
       //  console.log(eventObject.status)
        if (eventObject.status === "PENDING"){
          classString += ' provisional';
        }

        if(customer.appointmentsCount === 1){
          classString += ' first-appointment';
        }

        if(eventObject.address.postcode === 'LE9 7EF'){
          classString += ' at-bullpit'
        }

        if(eventObject.type && eventObject.type.id){
          classString += ' type-' + eventObject.type.name.toLowerCase().replace(/\s+/g, '-')
        }

        // console.log('parsing event ', eventObject)

        const appointmentType = new AppointmentType(eventObject.type.id, eventObject.type.name);

        this.calendarEvents.push({
          id: eventObject.id,
          title: customer.getFullName() + " " + appointmentType.abbreviation + " (" + customer.appointmentsCount + ")",
          date: eventObject.startTime,
          end: eventObject.endTime,
          allDay: false,
          durationEditable: true,
          editable: true,
          timeFormat: {
            hour: 'numeric',
            minute: '2-digit',
            meridiem: false
          },
          className: classString

        });
      })


      // get, iterate and populate google events
      const gcalEvents = await this.getUserGoogleEvents()
      if(!gcalEvents || !gcalEvents.data || !gcalEvents.data.items){
        return;
      }
      gcalEvents.data.items.forEach(googleEvent => {
        let startMoment: string;
        let endMoment: string;
        let allDay = false;
        if (googleEvent.end.date) {
          startMoment = moment(googleEvent.start.date).toISOString();
          endMoment = moment(googleEvent.end.date).toISOString();
          allDay = true;
        } else {
          startMoment = moment(googleEvent.start.dateTime).toISOString();
          endMoment = moment(googleEvent.end.dateTime).toISOString();
        }

        this.calendarEvents.push({
          id: googleEvent.id,
          title: googleEvent.summary,
          date: startMoment,
          end: endMoment,
          allDay,
          durationEditable: false,
          editable: false,
          
          textColor: '#FFF',
          timeFormat: {
            hour: 'numeric',
            minute: '2-digit',
            meridiem: false
          },
          className: 'gcal-event',
          //rrule: (googleEvent.recurrence) ? googleEvent.recurrence : null
          rrule:  (googleEvent.recurrence) ? this.convertRRule(googleEvent.recurrence, startMoment) : null
        });
      });

      


    } catch(e){
      console.log("Caught error while getting events for dates", e)
    }

    
  }

  // populateEventsToCalendarOLD(){
  //   this.apiService.appointments.getWithinDates(
  //     moment(this.calendarApi.view.currentStart).subtract(7, 'days').format('YYYY-MM-DD'),
  //     moment(this.calendarApi.view.currentEnd).add(7, 'days').format('YYYY-MM-DD'),
  //     false)
  //   .then((response) => {

  //     if(!response.success) {
  //       return;
  //     }
  //     this.calendarEvents = [];
  //     console.log(response)
  //     if(response.data.results && response.data.results.length === 0){
  //       return
  //     }
  //     response.data.forEach(eventObject => {
  //       const customer = new Customer().deserialize(eventObject.customer);

  //       var classString = 'fitter-' + eventObject.fitter.id;
  //       if (eventObject.type.id === 13){
  //         classString += ' provisional';
  //       }

  //       if(customer.appointmentsCount === 1){
  //         classString += ' first-appointment';
  //       }

  //       if(eventObject.address.postcode === 'LE9 7EF'){
  //         classString += ' at-bullpit'
  //       }

  //       console.log('parsing event ', eventObject)

  //       const appointmentType = new AppointmentType(eventObject.type.id, eventObject.type.name);

  //       this.calendarEvents.push({
  //         id: eventObject.id,
  //         title: customer.getFullName() + " " + appointmentType.abbreviation + " (" + customer.appointmentsCount + ")",
  //         date: eventObject.startTime,
  //         end: eventObject.endTime,
  //         allDay: false,
  //         durationEditable: true,
  //         editable: true,
  //         timeFormat: {
  //           hour: 'numeric',
  //           minute: '2-digit',
  //           meridiem: false
  //         },
  //         className: classString

  //       });
  //     });
  //     return this.getUserGoogleEvents();

  //   })
  //   .then((gcalEvents) => {
  //     console.log('gcalEvents ', gcalEvents)
  //     if(!gcalEvents || !gcalEvents.data || !gcalEvents.data.items){
  //       return;
  //     }
  //     gcalEvents.data.items.forEach(googleEvent => {
  //       let startMoment: string;
  //       let endMoment: string;
  //       let allDay = false;
  //       if (googleEvent.end.date) {
  //         startMoment = moment(googleEvent.start.date).toISOString();
  //         endMoment = moment(googleEvent.end.date).toISOString();
  //         allDay = true;
  //       } else {
  //         startMoment = moment(googleEvent.start.dateTime).toISOString();
  //         endMoment = moment(googleEvent.end.dateTime).toISOString();
  //       }

  //       this.calendarEvents.push({
  //         id: googleEvent.id,
  //         title: googleEvent.summary,
  //         date: startMoment,
  //         end: endMoment,
  //         allDay,
  //         durationEditable: false,
  //         editable: false,
  //         backgroundColor: 'rgb(11, 128, 67)',
  //         textColor: '#FFF',
  //         timeFormat: {
  //           hour: 'numeric',
  //           minute: '2-digit',
  //           meridiem: false
  //         },
  //         className: 'gcal-event',
  //         rrule: (googleEvent.recurrence) ? googleEvent.recurrence : null
  //       });
  //     });

  //     console.log({events: this.calendarEvents})



  //   })
  //   .catch((err) => { console.log(err) });
  // }

  getUserGoogleEvents(): Promise<any>{
    // console.log("Get google dates ")
    this.gettingGoogleEvents = true
    return new Promise((resolve, reject) => {
     // console.log(moment(this.calendarApi.view.currentStart).subtract(3, 'days').format('YYYY-MM-DD'));
     // console.log(moment(this.calendarApi.view.currentEnd).add(3, 'days').format('YYYY-MM-DD'));
      if (!this.additionalCalendarId){
        this.gettingGoogleEvents = false
        resolve([]);
        return;
      }
      this.apiService.user.getGCalEventsWithinDates(moment(this.calendarApi.view.currentStart).subtract(7, 'days').format('YYYY-MM-DD'),moment(this.calendarApi.view.currentEnd).add(7, 'days').format('YYYY-MM-DD'))
      .then((response) => {
        resolve(response);
        this.gettingGoogleEvents = false
      })
      .catch((err) => { console.log(err); this.gettingGoogleEvents = false });
    });
  }

  startCreateAppointmentClicked() {
    this.appointment = new Appointment();
    this.appointment.startTime = moment(this.startTime);
    this.appointment.endTime = moment(this.endTime);
  }
  cancelCreateAppointmentClicked() {
    this.appointment = null;
  }

  handleDateClick($event) {
    // console.log($event);
    this.calendarViewUpdatedByUser = true
    if ($event.view.type === 'dayGridMonth' || $event.view.type === 'timeGridWeek' || $event.view.type === 'multiMonthYear') {
      // A month day was clicked, so show the day
      this.calendarApi.changeView('timeGridDay', $event.date);
    }

    if ($event.view.type === 'timeGridDay'){
      const clickedTime = moment($event.date);
      const newAppointment = new Appointment();
      newAppointment.startTime = clickedTime;
      newAppointment.endTime = clickedTime.clone().add(1, 'hours');
      this.openAppointmentPane(true, newAppointment)     

    }


  }

  openAppointmentPane(newAppointment: boolean, appointment?: Appointment){
    if(newAppointment){      
      this.addUrlParam("appt", "new")
    } else {
      this.removeUrlParam("edit")
    }
  

    // this.appointmentEditSlideover.appointment = appointment
    // this.appointmentEditSlideover.initAppointment()
    // this.appointmentEditSlideover.open = true
    this.appointmentEditorService.setOpen(appointment)


  }

  handleEventClick($event: EventClickArg) {
    if($event.event.classNames.includes('gcal-event')){
      return;
    }
    
    this.updateURLForView($event, true)
    // this.router.navigateByUrl('/appointment/' + $event.event.id);
    this.openAppointmentPane(false,  new Appointment())
    
  }

  eventWasResized($event) {
    console.log($event);
    this.apiService.appointments.updateStartEndTimes(
      $event.event.id,
      moment($event.event.start).format('YYYY-MM-DD HH:mm:ss'),
      moment($event.event.end).format('YYYY-MM-DD HH:mm:ss'))
      .then((response) => {
        console.log('Event drag completed', response);
      })
      .catch((err) => { console.log(err) });
  }

  eventWasDragged($event) {

    this.apiService.appointments.updateStartEndTimes(
      $event.event.id,
      moment($event.event.start).format('YYYY-MM-DD HH:mm:ss'),
      moment($event.event.end).format('YYYY-MM-DD HH:mm:ss'))
      .then((response) => {
        console.log('Event drag completed', response);
      })
      .catch((err) => { console.log(err) });
  }

  appointmentWasCreated() {
    this.appointment = null;
    this.populateEventsToCalendar();
  }

  swipedLeft($event){
    this.calendarApi.next();
  }

  swipedRight(){
    this.calendarApi.prev();
  }

/**
 * Function to return either the start date, the first day of the month of the end date,
 * or the first day of the month following the start date
 * @param {Date} startDate - The start date
 * @param {Date} endDate - The end date
 * @returns {Date} - The start date if it's the first day of the month, 
 *                   the start date if in the same month/year,
 *                   the first day of the end date's month/year,
 *                   or the first day of the month following the start date
 */
getRelevantDate(startDate, endDate) {

  // Check if the start date is the first day of the month
  if (getDate(startDate) === 1) {
    return startDate;
  }

  // Check if the start and end dates are in the same month and year
  if (isSameMonth(startDate, endDate)) {
    return startDate;
  }

  // Check if the end date is in the month directly following the start date
  const nextMonthAfterStartDate = addMonths(startDate, 1);
  if (isSameMonth(nextMonthAfterStartDate, endDate)) {
    return startOfMonth(endDate);
  }

  // Return the first day of the month following the start date
  return startOfMonth(nextMonthAfterStartDate);
}

toLocalISOString(date) {
  const pad = (num) => (num < 10 ? '0' + num : num);

  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1); // Months are zero-indexed
  const day = pad(date.getDate());
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  const seconds = pad(date.getSeconds());

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
}

convertRRule(googleRRule: string[], dtstart: string): RRuleObject {
  const rruleObject: RRuleObject = {};
  const exdateArray: string[] = [];

  googleRRule.forEach(rule => {
    if (rule.startsWith('RRULE:')) {
      const rruleParts = rule.replace('RRULE:', '').split(';');
      rruleParts.forEach(part => {
        const [key, value] = part.split('=');
        if (key.toLowerCase() === 'freq') {
          rruleObject.freq = value.toLowerCase();
        }
        // Add more fields if needed (like interval, until, etc.)
      });
    } else if (rule.startsWith('EXDATE;VALUE=DATE:')) {
      const exdates = rule.replace('EXDATE;VALUE=DATE:', '').split(',');
      exdateArray.push(...exdates);
    }
  });

  const fullCalendarRRule: RRuleObject = {
    freq: rruleObject.freq,
    dtstart: dtstart,
    // exdate: exdateArray.map(date => date + 'T00:00:00Z') // Append time to EXDATE
  };

  return fullCalendarRRule;
}

appointmentDetailsWasClosed(){
  this.removeUrlParam("appt")
}


  // @HostListener('window:scroll', ['$event']) onScrollEvent($event){
  //     console.log('window.pageYOffset ', window.pageYOffset);
  //     console.log('window.scrollY ', window.scrollY);
  //     console.log('document.body.offsetHeight ', document.body.offsetHeight);
  //   if (window.pageYOffset > (window.outerHeight * 0.5)) {
  //     console.log('At bottom!!');
  //     window.scrollTo(0,0);
  //     this.calendarApi.next();
  // }
  // }

}


